export function show3DViewButton() {
  const buttons = [...document.querySelectorAll('.c-button-3d')]

  const display3dViews = [...document.querySelectorAll('.c-product-hero__3d')]
  const gallery = document.querySelector('.c-product-hero__gallery')
  const sliderNav = document.querySelector('.c-slide-controls--product')
  buttons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const btnIndex = btn.dataset.index
      display3dViews.forEach((view) => {
        const viewIndex = view.dataset.index
        if (btnIndex == viewIndex) {
          view.classList.add('u-is-shown')
          gallery.classList.add('u-visibility-hidden')
          sliderNav.classList.add('u-visibility-hidden')
          const revertButton = view.querySelector('.c-button-3d')
          revertButton.addEventListener('click', (e) => {
            sliderNav.classList.remove('u-visibility-hidden')
            view.classList.remove('u-is-shown')
            // view.classList.remove('u-no-translate')
            gallery.classList.remove('u-visibility-hidden')
          })
        }
      })
    })
  })
}
